import { StripeService } from "./services/stripeService";
import { metaPixelService } from "./services/metaPixelService";
import { hasSensitiveSearch } from "./utils/analyticsUrl";
import { readMarketingConsent } from "./utils/cookieConsent";

export const SIGNUP_CONTENT_NAME = "PEAK";
export const SIGNUP_CURRENCY = "USD";

const CHECKOUT_KEY = "peak_signup_meta_checkout";
const REGISTRATION_KEY = "peak_signup_meta_registration";
const SUBSCRIBE_KEY = "peak_signup_meta_subscribe";

export interface PendingCheckout {
  name: string;
  value: number;
  priceId: string;
}

function canTrack(): boolean {
  return readMarketingConsent() && !hasSensitiveSearch(window.location.search);
}

export function trackCompleteRegistration() {
  if (!canTrack()) return;
  if (sessionStorage.getItem(REGISTRATION_KEY)) return;
  sessionStorage.setItem(REGISTRATION_KEY, "1");
  metaPixelService.track("CompleteRegistration", {
    content_name: SIGNUP_CONTENT_NAME,
    status: true,
  });
}

export function trackInitiateCheckout(plan: {
  type: "plus" | "premium";
  name: string;
  billingPeriod: "month" | "year";
}) {
  const value = StripeService.getPeakDisplayPrice(plan.type, plan.billingPeriod);
  const priceId = StripeService.getPeakPriceId(plan.type, plan.billingPeriod);
  const pending: PendingCheckout = { name: plan.name, value, priceId };
  sessionStorage.setItem(CHECKOUT_KEY, JSON.stringify(pending));
  if (!canTrack()) return;
  metaPixelService.track("InitiateCheckout", {
    content_name: `${SIGNUP_CONTENT_NAME} ${plan.name}`,
    content_ids: [priceId],
    content_type: "product",
    value,
    currency: SIGNUP_CURRENCY,
  });
}

export function trackSubscribeReturn() {
  if (!canTrack()) return;
  if (sessionStorage.getItem(SUBSCRIBE_KEY)) return;
  const raw = sessionStorage.getItem(CHECKOUT_KEY);
  let pending: PendingCheckout | null = null;
  if (raw) {
    try {
      pending = JSON.parse(raw) as PendingCheckout;
    } catch {
      pending = null;
    }
  }
  sessionStorage.setItem(SUBSCRIBE_KEY, "1");
  metaPixelService.track("Subscribe", {
    content_name: pending ? `${SIGNUP_CONTENT_NAME} ${pending.name}` : SIGNUP_CONTENT_NAME,
    ...(pending?.priceId ? { content_ids: [pending.priceId] } : {}),
    content_type: "product",
    ...(typeof pending?.value === "number"
      ? { value: pending.value, currency: SIGNUP_CURRENCY, predicted_ltv: pending.value }
      : {}),
  });
}
